import {gql} from '@apollo/client';
import {Button, Spinner} from 'evergreen-ui';
import {getDomainGraphqlError, useMutation$} from 'graphqlsupport';
import React, {useCallback} from 'react';
import {useObservable} from 'rxsupport';
import {showToast} from "common";

type ResendInvitationInput = {
    oktaId: string;
};
const RESEND_INVITATION_MUTATION = gql`
    mutation resendInvitation($oktaId: String!) {
        resendInvitationEmail(oktaId: $oktaId)
    }
`;
const useResendInvitationMutation$ = () => {
    const {execute, isRunning$,} = useMutation$<ResendInvitationInput, void>(RESEND_INVITATION_MUTATION);
    const wrappedExecute = useCallback(async (input: ResendInvitationInput) => {
        try {
            const {data} = await execute({
                variables: input,
            });
            if (data) {
                showToast.success(`An invitation email has been sent`);
            }
        } catch (errors: any) {
            showToast.error(getDomainGraphqlError(errors) ?? `Unable to resend invitation email: ${errors.message || errors[0].message}`);
        }
    }, [execute]);
    return {
        isRunning$,
        submit: wrappedExecute,
    };
};

type ResendActivationEmailButtonProps = {
    userOktaId: string;
    status: string;
}
export const ResendActivationEmailButton = ({userOktaId, status}: ResendActivationEmailButtonProps) => {
    const {
        isRunning$,
        submit: send,
    } = useResendInvitationMutation$()
    const isRunning = useObservable(isRunning$, false)

    if (status !== 'PROVISIONED') {
        return null;
    }
    return (
        <Button type='button'
                appearance='minimal' intent='success' marginLeft={8}
                onClick={() => send({oktaId: userOktaId})}
                disabled={isRunning}
                className='ev-overwrite ev-resend-invitation-action'
        >
            {isRunning ? <Spinner size={16} marginX='auto'/>: 'Resend Activation Email'}
        </Button>
    );
};
